class ClientEdit {
  constructor(data = {}) {
    this.idCliente = data.idCliente || 0;
    this.nombre = data.nombre || "";
    this.nombreCorto = data.nombreCorto || "";
    this.rfc = data.rfc || "";
    this.codigo = data.codigo || "";
    this.correo = data.correo || "";
    this.ciudad = data.ciudad || "";
    this.calle = data.calle || "";
    this.colonia = data.colonia || "";
    this.codigoPostal = data.codigoPostal || "";
    this.noExterior = data.noExterior || "";
    this.estatus = data.estatus || true;
    this.url = data.url || "";
    this.usuario = data.usuario || "";
    this.contrasena = data.contrasena || "";
  }
}

class ClientAdd {
  constructor(data = {}) {
    this.idCliente = data.idCliente || 0;
    this.nombre = data.nombre || "";
    this.nombreCorto = data.nombreCorto || "";
    this.rfc = data.rfc || "";
    this.codigo = data.codigo || "";
    this.correo = data.correo || "";
    this.ciudad = data.ciudad || "";
    this.calle = data.calle || "";
    this.colonia = data.colonia || "";
    this.codigoPostal = data.codigoPostal || "";
    this.noExterior = data.noExterior || "";
    this.estatus = data.estatus || true;
    this.url = data.url || "";
    this.usuario = data.usuario || "";
    this.contrasena = data.contrasena || "";
  }
}

export { ClientEdit, ClientAdd };
